export const environment = {
  production: true,
  apiUrl: 'https://api.onlyusedtesla.com',
  featureXEnabled: true,
  country: 'USA', //UK or CA
  referer: 'https://onlyusedtesla.com/',
  authentication: true,
  STRIPE_PK: 'pk_live_Kxt2ezjESxY6U9zTI0Rr74gZ',
  GOOGLE_TAG_MANAGER_ID: 'GTM-KZFMZNT',
};
